import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import { forwardRef } from 'react';

import styles from './JackpotInfoBlock.scss';

export interface Props {
  title: TranslationTag;
  amount: string;
  className?: string;
  fontSize?: number;
}

const JackpotInfoBlock = forwardRef<HTMLParagraphElement, Props>(
  ({ title, amount, fontSize, className }, ref) => (
    <div className={classNames(className, styles.tabs)}>
      <p className={styles.jackpotTitle}>
        <Translation {...title} />
      </p>
      <p
        ref={ref}
        className={styles.jackpotText}
        data-text={amount}
        style={{ fontSize: `${fontSize}px` }}
      >
        {amount}
      </p>
    </div>
  )
);

export default JackpotInfoBlock;
